import React from "react";
import ProtectedRoute from "../components/ProtectedRoute";
/**
 * Login
 *
 * @var [type]
 */
const Login = React.lazy(() => import("../pages/Login"));
const SignUp = React.lazy(() => import("../pages/SignupRequest"));
const Redirect = React.lazy(() => import("../pages/Redirect"));
const ClientHome = React.lazy(() => import("../pages/client/ClientHome"));
const ClientAssessment = React.lazy(() => import("../pages/client/ClientAssessments"));
const ClientFramework = React.lazy(() => import("../pages/client/ClientFrameworks"));
const ClientReports = React.lazy(() => import("../pages/client/ClientReports"));
const ClientSettings = React.lazy(() => import("../pages/client/ClientSettings"));
const ClientUsers = React.lazy(() => import("../pages/client/ClientUsers"));
const ClientDocuments = React.lazy(() => import("../pages/client/ClientDocuments"));
const AssessmentReport = React.lazy(() => import("../pages/client/AssessmentReport"));
const OnboardingWizard = React.lazy(() => import("../pages/onboarding/OnboardingWizard"));
const ClientHistory = React.lazy(() => import("../pages/client/ClientHistory"));


const routes = [
    {
        path: "/login",
        element: <Login />,
        layout: false,
        auth: false,
    },
    {
        path: "/signup",
        element: <SignUp />,
        layout: false,
        auth: false,
    },
    {
        path: "/",
        element: <ProtectedRoute><ClientHome /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Dashboard"
    },
    {
        path: "/assessments",
        element: <ProtectedRoute><ClientAssessment /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Assessments"
    },
    {
        path: "/frameworks",
        element: <ProtectedRoute><ClientFramework /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Frameworks"
    },
    {
        path: "/documents",
        element: <ProtectedRoute><ClientDocuments /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Documents & Evidence"
    },
    {
        path: "/reports",
        element: <ProtectedRoute><ClientReports /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Reports"
    },
    {
        path: "/users",
        element: <ProtectedRoute><ClientUsers /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Users"
    },
    {
        path: "/settings",
        element: <ProtectedRoute><ClientSettings /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Settings"
    },
    {
        path: "/assessment-report",
        element: <ProtectedRoute><AssessmentReport /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Assessment Report"
    },
    {
        path: "/history",
        element: <ProtectedRoute><ClientHistory /></ProtectedRoute>,
        layout: true,
        auth: true,
        title: "Activity History"
    },
    {
        path: "/onboarding/:frameworkId/*",
        element: <OnboardingWizard />,
        layout: true,
        auth: true,
        title: "Onboarding Wizard"
    },
    {
        path: "/redirect",
        element: <Redirect />,
        layout: false,
        auth: false,
    }
];

export default routes;